export enum BillingFrequency {
  Weekly = 1,
  Biweekly = 2,
  Monthly = 3,
  Yearly = 4,
}
